import React from 'react';
import { Typography } from '@mui/material';
import { AccountCircleOutlined } from '@mui/icons-material';

const Welcome = ({ mode = 'list', compact = false }) => {
    return (
        <div style={{ textAlign: "center" }}>
            <Typography variant={compact ? "h4" : "h3"} sx={{ fontWeight: "700", mb: compact ? 1.5 : 2 }} className='icon'>Welcome</Typography>
            <AccountCircleOutlined className="icon" sx={{ fontSize: compact ? "72px" : "100px", borderRadius: "50%", mb: compact ? 1.5 : 2 }} />
            <Typography variant={compact ? "h6" : "h5"} >
                {mode === 'userId'
                    ? 'Please enter your kiosk User ID to start'
                    : 'Please select employee in the list to start'}
            </Typography>
        </div>
    );
};

export default Welcome;   